document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const seriesName = urlParams.get('filter.p.m.custom.series_name');
    
    if (urlParams.has('vendor')) {
        const activeFacets = document.querySelector(".active-facets");
        if (activeFacets) {
            activeFacets.style.display = "none";
        }
    }

    if (seriesName) {
        const decodedSeriesName = decodeURIComponent(seriesName);
        const container = document.querySelector('.h1');
        if (container) {
            container.textContent = decodedSeriesName;
        }

        const breadcrumbItems = document.querySelectorAll('.breadcrumb__list-item');
        if (breadcrumbItems.length > 0) {
            const lastBreadcrumbItem = breadcrumbItems[breadcrumbItems.length - 1];
            const breadcrumbLink = lastBreadcrumbItem.querySelector('a');
            if (breadcrumbLink) {
                breadcrumbLink.textContent = decodedSeriesName;
            }
        }
    }
});



